import instanceAxios from '@/util/axios';
import { LoginApiRequest } from '@sm-dashboard/reshet-types';
import { LoginRequest, LoginResponse, LoginApiResponse } from './login.types';
import { loginUrl } from '@/constants';

function mapRequestToApi(request: LoginRequest): LoginApiRequest {
  return { ...request };
}

function mapResponseToApp(response: LoginApiResponse): LoginResponse {
  return response as LoginResponse;
}

export async function login(request: LoginRequest): Promise<LoginResponse> {
  const requestApi = mapRequestToApi(request);
  const response = await instanceAxios.post<LoginApiResponse>(loginUrl, requestApi);
  return mapResponseToApp(response.data as unknown as LoginApiResponse);
}
